"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HederaReserve__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "AddressZero",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "int256",
                name: "previousAmount",
                type: "int256",
            },
            {
                indexed: false,
                internalType: "int256",
                name: "newAmount",
                type: "int256",
            },
        ],
        name: "AmountChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "int256",
                name: "initialReserve",
                type: "int256",
            },
        ],
        name: "ReserveInitialized",
        type: "event",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "description",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint80",
                name: "",
                type: "uint80",
            },
        ],
        name: "getRoundData",
        outputs: [
            {
                internalType: "uint80",
                name: "",
                type: "uint80",
            },
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint80",
                name: "",
                type: "uint80",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "initialReserve",
                type: "int256",
            },
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "latestRoundData",
        outputs: [
            {
                internalType: "uint80",
                name: "roundId",
                type: "uint80",
            },
            {
                internalType: "int256",
                name: "answer",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "startedAt",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "updatedAt",
                type: "uint256",
            },
            {
                internalType: "uint80",
                name: "answeredInRound",
                type: "uint80",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
        ],
        name: "setAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "newValue",
                type: "int256",
            },
        ],
        name: "setAmount",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "version",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class HederaReserve__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.HederaReserve__factory = HederaReserve__factory;
HederaReserve__factory.bytecode = _bytecode;
HederaReserve__factory.abi = _abi;
